import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, unref as _unref, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue"

import { LPadrao } from "@/layouts/"
  import TPainelDeEstatisticas from "@/components/Estatisticas/TPainelDeEstatisticas/TPainelDeEstatisticas.vue"
  import { MenuItem } from "primevue/menuitem"
  import { ref } from "vue"
  import { useI18n } from "vue-i18n"

  
export default /*#__PURE__*/_defineComponent({
  __name: 'Estatisticas',
  setup(__props) {

  const { t } = useI18n()

  const home = ref<MenuItem>({
    label: t("estatisticas"),
    icon: "pi pi-chart-line",
    to: "/estatisticas",
  })

  const breadCrumbItems = ref<MenuItem[]>([])

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(_unref(LPadrao), null, {
    default: _withCtx(() => [
      _createVNode(TPainelDeEstatisticas, {
        "bread-crumb-items": breadCrumbItems.value,
        home: home.value
      }, null, 8, ["bread-crumb-items", "home"])
    ]),
    _: 1
  }))
}
}

})